class Surg {
    constructor(apiService = null) {
        this.obj_name = 'surg';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 表單檢查
    checkCreateFormModel(formData) {
        const validations = [
            { condition: formData.anesthesia_type === -1, message: '請選擇手術類型' },
            { condition: formData.tube_size === -1, message: '請選擇插管尺寸' },
            { condition: formData.BW_actual === '', message: '請輸入實際體重' },
            { condition: formData.assistant_surgeon === '', message: '請選擇主刀醫師' },
            { condition: formData.assistant_surgeon === '', message: '請選擇副刀醫師' },
            { condition: formData.anesthesiologist === '', message: '請選擇麻醉醫師' },
            { condition: formData.anesthesia_assistant === '', message: '麻醉助理' },
            { condition: formData.surgical_details === '', message: '請輸入手術內容' },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // API 方法
    //手術麻醉 | 101搜尋手術麻醉
    async getSurgeryByKeywordWithPage(parameter) {
        return this.callApi('get', 'getSurgeryByKeywordWithPage', parameter);
    }
    //手術麻醉 | 102取得手術麻醉資料
    async getSurgeryRecordById(parameter) {
        return this.callApi('get', 'getSurgeryRecordById', parameter);
    }
    //手術麻醉 | 103新增手術麻醉
    async addSurgeryRecord(parameter, progressEvent = null) {
        return this.callApi('post', 'addSurgeryRecord', parameter, progressEvent);
    }
    //手術麻醉 | 104更新手術麻醉
    async updSurgeryRecord(parameter, progressEvent = null) {
        return this.callApi('post', 'updSurgeryRecord', parameter, progressEvent);
    }
    //手術麻醉 | 105新增手術用藥
    async addOrDelSurgicalMedicationUseJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrDelSurgicalMedicationUseJson', parameter, progressEvent);
    }
    //手術麻醉 | 106取得手術用藥資料
    async getSurgicalMedicationBySurgeryRecordId(parameter) {
        return this.callApi('get', 'getSurgicalMedicationBySurgeryRecordId', parameter);
    }
    //手術麻醉 | 107新增手術耗材
    async addOrDelSurgicalConsumablesUseJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrDelSurgicalConsumablesUseJson', parameter, progressEvent);
    }
    //手術麻醉 | 108取得手術耗材資料
    async getSurgicalConsumablesBySurgeryRecordId(parameter) {
        return this.callApi('get', 'getSurgicalConsumablesBySurgeryRecordId', parameter);
    }
    //手術麻醉 | 109取得手術麻醉紀錄
    async getSurgeryVitalSignsAndAnesthesiaDrugsBySurgeryId(parameter) {
        return this.callApi('get', 'getSurgeryVitalSignsAndAnesthesiaDrugsBySurgeryId', parameter);
    }
    //手術麻醉 | 110新增手術麻醉紀錄
    async addVitalSignsAndAnesthesiaDrugs(parameter, progressEvent = null) {
        return this.callApi('post', 'addVitalSignsAndAnesthesiaDrugs', parameter, progressEvent);
    }

    //手術麻醉 | 111更新手術狀態
    async updSurgeryRecordIsDisable(parameter, progressEvent = null) {
        return this.callApi('post', 'updSurgeryRecordIsDisable', parameter, progressEvent);
    }
    
}

export default Surg;
